/**
 * Twilio Secret patterns:
 *
 * Twilio uses Account SIDs and Auth Tokens for their communication platform API.
 *
 * Patterns:
 * 1. Twilio Account SID:
 *    - Starts with 'AC' followed by 32 hexadecimal characters
 *    - Total length: 34 characters
 *
 * 2. Twilio Auth Token:
 *    - 32 character hexadecimal string
 *    - Often appears with TWILIO_AUTH_TOKEN or similar variable names
 *
 * 3. Twilio API Key SID:
 *    - Starts with 'SK' followed by 32 hexadecimal characters
 *    - Total length: 34 characters
 *
 * Examples:
 * - Account SID: `AC1234567890abcdef1234567890abcdef`
 * - Auth Token: `1234567890abcdef1234567890abcdef`
 * - API Key SID: `SK1234567890abcdef1234567890abcdef`
 *
 * References:
 * - https://www.twilio.com/docs/iam/credentials/api-keys
 * - https://www.twilio.com/docs/usage/secure-credentials
 */

export const twilioAccountSid = /\bAC[a-fA-F0-9]{32}\b/;
export const twilioApiKeySid = /\bSK[a-fA-F0-9]{32}\b/;
export const twilioAuthToken =
  /(?:TWILIO_AUTH_TOKEN|twilio_auth_token|auth_token)["']?\s*[:=]\s*["']?([a-fA-F0-9]{32})["']?/i;
